import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {OmgIndicator} from "../../profile-box-messages-indicator/indicators/omg-indicator.component";
import {FreeplayIndicator} from "../../profile-box-messages-indicator/indicators/freeplay-indicator.component";
import {LoyaltyBar} from "../../loyalty-bar/loyalty-bar.component";
import {UserDetails} from "../../user-details/user-details.component";
import {observer} from "mobx-react";
import {UsefulLinks} from "../../useful-links/useful-links.component";
import {UserBalance} from "../../balance-box/user-balance.component";
import {DrawerBoxes} from "../../drawer-boxes/drawer-boxes.component";
import {MiniSafezoneComponent} from "../mini-safezone/mini-safezone.component";
import {UserMenuScrollWrapperBox} from "./boxes/user-menu-scroll-wrapper.box";
import { ProfileMessagesBox } from "../../profile-box/boxes/profile-box-messages/profile-messages.box";
import {UserMenuFakeIOSPaddingBox} from "./boxes/user-menu-fake-ios-padding.box";

@observer
export class UserMenuMobile extends OrbitComponent {
  render() {
    // NB: the PC layout has the profile-box-messages, loyalty bar, and
    // dynamics boxes in the SideMenu, whereas the mobile layout has them
    // here in the pop-out menu.

    return (
      <UserMenuScrollWrapperBox>
        <UserBalance />
        <ProfileMessagesBox className="cy-profile-box-messages">
          <OmgIndicator />
          <FreeplayIndicator />
        </ProfileMessagesBox>
        <LoyaltyBar />
        <DrawerBoxes />
        <UserDetails />
        <MiniSafezoneComponent/>

        <div className="hr-border-light-line"></div>
        <UsefulLinks />
          {this.services.device.os.isIOS && <UserMenuFakeIOSPaddingBox />}
      </UserMenuScrollWrapperBox>
    );
  }
}
